import { useSearchParams } from "react-router-dom";
import { useFetchTasks } from "../../../../../tasks/hooks/tasks.queries";
import {
    TaskCategory,
    TaskListSortAttribute,
    TaskStatus,
} from "../../../../../tasks/types/tasks.types";
import { useDebounce } from "../../../../../../hooks/helpers";
import { useFetchUserDetails } from "../../../../../../hooks/queries/user";
import { AppSortOrder } from "../../../../../../utils/types";
import ListState from "../../../../../../components/ListState/ListState";
import Task from "../../../../../tasks/components/Task/Task";
import useNewBackground from "../../../../../../hooks/useNewBackground";

export default function MyPendingTasks() {
    const [searchParams] = useSearchParams();

    const clientName = searchParams.get("task_client") || "";
    const fromDateFilter = searchParams.get("task_from_date");
    const toDateFilter = searchParams.get("task_to_date");

    const debouncedClientName = useDebounce(clientName);

    const useNewBg = useNewBackground();

    const loggedInUser = useFetchUserDetails();

    const { isLoading, error, data, isSuccess } = useFetchTasks({
        status: [TaskStatus.IN_PROGRESS, TaskStatus.NOT_STARTED],
        assignee_user_id: loggedInUser.data?.user_id || "",
        client_name: debouncedClientName,
        creator_user_id: loggedInUser.data?.user_id || "",
        user_id_query_logic: "OR",
        from_date: fromDateFilter,
        to_date: toDateFilter,
        sort_attribute: TaskListSortAttribute.DUE_DATE,
        sort_order: AppSortOrder.ASC,
        category: [
            TaskCategory.WRITE_SESSION_NOTE,
            TaskCategory.MAKE_REQUESTED_CHANGE,
            TaskCategory.USER_CREATED,
            TaskCategory.WRITE_FOLLOW_UP_SAFETY_NOTE,
        ],
    });

    return (
        <>
            {isLoading ? (
                <div
                    className="flex items-center justify-center h-full"
                    data-testid="loader"
                >
                    <span className="mid-loader" />
                </div>
            ) : null}
            {error ? (
                <div className="h-full text-sm font-medium flex items-center justify-center">
                    <ListState
                        isError
                        errorMsg={
                            error?.response?.data?.message ||
                            "Could not load pending tasks at this time"
                        }
                        stateHelperText="Try reloading this page to solve this issue"
                        context="general"
                        mode={useNewBg ? "new" : "old"}
                    />
                </div>
            ) : null}
            {isSuccess && data.data.length === 0 ? (
                <ListState
                    stateHelperText="No pending tasks found"
                    isError={false}
                    emptyMessage="No pending tasks"
                    context="general"
                    mode={useNewBg ? "new" : "old"}
                />
            ) : null}
            {isSuccess && data.data ? (
                <div className="flex flex-col gap-y-12">
                    {data.data.map((task) => (
                        <Task task={task} key={task.todo_id} />
                    ))}
                </div>
            ) : null}
        </>
    );
}
